import React from 'react'

export const IconLinkedIn = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 0.75H19C21.4853 0.75 23.5 2.76472 23.5 5.25V18.75C23.5 21.2353 21.4853 23.25 19 23.25H5.5C3.01472 23.25 1 21.2353 1 18.75V5.25C1 2.76472 3.01472 0.75 5.5 0.75ZM9.39754 17.25V9.41574H7.18443V17.25H9.39754ZM8.29098 8.51266C7.57836 8.51266 7 7.95002 7 7.25633C7 6.56264 7.57836 6 8.29098 6C9.00361 6 9.58197 6.56264 9.58197 7.25633C9.58197 7.95002 9.00434 8.51266 8.29098 8.51266ZM16.0369 17.25H18.25V12.4362C18.25 8.69499 14.1159 8.83102 13.0861 10.6728V9.41574H10.873V17.25H13.0861V13.2588C13.0861 11.0417 16.0369 10.8601 16.0369 13.2588V17.25Z"
      fill="currentColor"
    />
  </svg>
)
